import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { createInterceptors } from "./useAuthContex";

interface IProvideAuthContext {
  children: React.ReactNode;
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  context: {
    isLoggedIn: boolean;
  };
}
export const AuthContext = React.createContext<IProvideAuthContext>({
  children: null,
  token: "",
  setToken: token => token,
  context: {
    isLoggedIn: false
  }
});

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export const ProvideAuthContext: React.FC = ({ children }) => {
  const [token, setToken] = useState<string>("");
  const context: any = {
    isLoggedIn: !window.localStorage.getItem("token-crombie-docs")
  };
  const history = useHistory();

  createInterceptors({ navigate: history.push });
  return (
    <AuthContext.Provider value={{ context, children, token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};
